import { BoxProps } from '@jfs/ui-new'

export const styles = {
  otp: {
    progressStyle: {
      flexDirection: 'row',
      flex: 1,
      marginTop: 0,
      marginHorizontal: 6,
    } as BoxProps,
    progress: {
      borderTopWidth: 5,
      flex: 1,
    } as BoxProps,
    progFirst: {
      borderTopLeftRadius: 6,
      borderTopColor: 'GREEN',
      width: '33%',
      flex: 1,
      marginRight: 4,
    } as BoxProps,
    progMiddle: {
      width: '33%',
      borderTopColor: 'GREEN',
      flex: 1,
    } as BoxProps,
    progThird: {
      borderTopRightRadius: 6,
      borderTopColor: 'INACTIVE_GREY',
      width: '33%',
      flex: 1,
      marginLeft: 4,
    } as BoxProps,
  },

  forgotPassword: {
    progressStyle: {
      flexDirection: 'row',
      flex: 1,
      marginTop: -7,
      marginHorizontal: -1,
    } as BoxProps,
    progress: {
      borderTopWidth: 5,
      flex: 1,
    } as BoxProps,
    progFirst: {
      borderTopLeftRadius: 14,
      borderTopColor: 'GREEN',
      width: '33%',
      flex: 1,
      marginRight: 4,
    } as BoxProps,
    progMiddle: {
      width: '33%',
      borderTopColor: 'INACTIVE_GREY',
      flex: 1,
    } as BoxProps,
    progThird: {
      borderTopRightRadius: 10,
      borderTopColor: 'INACTIVE_GREY',
      width: '33%',
      flex: 1,
      marginLeft: 4,
    } as BoxProps,
  },
  resetPassword: {
    progressStyle: {
      flexDirection: 'row',
      flex: 1,
      marginTop: 0,
      marginHorizontal: 6.5,
    } as BoxProps,
    progress: {
      borderTopWidth: 5,
      flex: 1,
    } as BoxProps,
    progFirst: {
      borderTopLeftRadius: 16,
      borderTopColor: 'GREEN',
      width: '33%',
      flex: 1,
      marginRight: 4,
    } as BoxProps,
    progMiddle: {
      width: '33%',
      borderTopColor: 'GREEN',
      flex: 1,
    } as BoxProps,
    progThird: {
      borderTopRightRadius: 16,
      borderTopColor: 'GREEN',
      width: '33%',
      flex: 1,
      marginLeft: 4,
    } as BoxProps,
  },
  signupStep0: {
    progressStyle: {
      display: 'flex',
      flexDirection: 'row',
      flex: 1,
      marginTop: -21,
      marginHorizontal: 1,
    } as BoxProps,
    progress: {
      borderTopWidth: 5,
      flex: 1,
    } as BoxProps,
    progFirst: {
      borderTopLeftRadius: 10,
      borderTopColor: 'GREEN',
      width: '33%',
      flex: 1,
      marginRight: 4,
    } as BoxProps,
    progMiddle: {
      width: '33%',
      borderTopColor: 'INACTIVE_GREY',
      flex: 1,
    } as BoxProps,
    progThird: {
      borderTopRightRadius: 10,
      borderTopColor: 'INACTIVE_GREY',
      width: '33%',
      flex: 1,
      marginLeft: 4,
    } as BoxProps,
  },
  signupStep1: {
    progressStyle: {
      display: 'flex',
      flexDirection: 'row',
      flex: 1,
      marginTop: -21,
      marginHorizontal: 1,
    } as BoxProps,
    progress: {
      borderTopWidth: 5,
      flex: 1,
    } as BoxProps,
    progFirst: {
      borderTopLeftRadius: 10,
      borderTopColor: 'GREEN',
      width: '33%',
      flex: 1,
      marginRight: 4,
    } as BoxProps,
    progMiddle: {
      width: '33%',
      borderTopColor: 'GREEN',
      flex: 1,
    } as BoxProps,
    progThird: {
      borderTopRightRadius: 10,
      borderTopColor: 'INACTIVE_GREY',
      width: '33%',
      flex: 1,
      marginLeft: 4,
    } as BoxProps,
  },
  signupStep2: {
    progressStyle: {
      display: 'flex',
      flexDirection: 'row',
      flex: 1,
      marginTop: -21,
      marginHorizontal: 1,
    } as BoxProps,
    progress: {
      borderTopWidth: 5,
      flex: 1,
    } as BoxProps,
    progFirst: {
      borderTopLeftRadius: 10,
      borderTopColor: 'GREEN',
      width: '33%',
      flex: 1,
      marginRight: 4,
    } as BoxProps,
    progMiddle: {
      width: '33%',
      borderTopColor: 'GREEN',
      flex: 1,
    } as BoxProps,
    progThird: {
      borderTopRightRadius: 10,
      borderTopColor: 'GREEN',
      width: '33%',
      flex: 1,
      marginLeft: 4,
    } as BoxProps,
  },
}
